import {
  get,
  post,
  del,
} from '@/utils/request';

const url = 'error-logs';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getYouZanList(data) {
  return get({
    url: `${url}/you-zan-logs`,
    data,
  });
}

export function getWeChatOrderList(data) {
  return get({
    url: `${url}/we-chat-orders`,
    data,
  });
}

export function getYouZanDetails(id) {
  return get({
    url: `${url}/you-zan-logs/${id}`,
  });
}

export function getWeChatOrderDetails(id) {
  return get({
    url: `${url}/we-chat-orders/${id}`,
  });
}

export function getWorkWeChatList(data) {
  return get({
    url: `${url}/work-we-chat`,
    data,
  });
}

export function getWorkWeChatDetails(id) {
  return get({
    url: `${url}/work-we-chat/${id}`,
  });
}

export function getWeChatSubscribeList(data) {
  return get({
    url: `${url}/subscribe-messages`,
    data,
  });
}

export function getSmsList(data) {
  return get({
    url: `${url}/sms`,
    data,
  });
}

// 未设置有赞商品签到日期时是否记录日志
export function getYouZanEmptyDateLogIsEnable() {
  return get({
    url: `${url}/you-zan-logs/empty-date-settings`,
  });
}

// 商品未设置签到日期则录入日志
export function enableYouZanEmptyDateLog() {
  return post({
    url: `${url}/you-zan-logs/empty-date-settings`,
  });
}

// 商品未设置签到日期则不录入日志
export function disableYouZanEmptyDateLog() {
  return del({
    url: `${url}/you-zan-logs/empty-date-settings`,
  });
}
